import { useRef } from 'react'
import css from './gridLayout.module.css'
import { TCompactType, IPositionParams, TLayout } from './grid.types'
import GridItem from './components/GridItem'
import PlaceholderLayout from './components/PlaceholderLayout'
import gridLayoutConstants from './gridLayout.constants'
import useGridLayout from './hooks/useGridLayout'

interface IProps {
  layout: TLayout
  positionParams: IPositionParams
  compactType?: TCompactType
  onLayoutChange?: (layout: TLayout) => void
}

const GridLayout = ({ compactType = 'vertical', ...props }: IProps) => {
  const containerRef = useRef<HTMLDivElement>()

  const ctrl = useGridLayout({ ...props, compactType, containerRef })

  return (
    <div ref={containerRef} className={css.gridContainer} id={gridLayoutConstants.gridContainerId}>
      {ctrl.layoutRef.current.map((item) => (
        <GridItem
          key={item.key}
          gridItem={item}
          posParams={ctrl.positionParams}
          onDrag={ctrl.onDrag}
          onResize={ctrl.onResize}
          onActiveElementChange={ctrl.onActiveElementChange}
          forceUpdate={ctrl.forceUpdate}
        />
      ))}
      <PlaceholderLayout
        positionParams={ctrl.positionParams}
        activeElement={ctrl.activeElement}
        layout={ctrl.layoutRef.current}
        forceUpdate={ctrl.forceUpdate}
      />
    </div>
  )
}

export default GridLayout
